import React, { Fragment } from 'react';

import GenericHeader from '../../../common/pageHeader/GenericHeader';
import Text from '../../../common/form/Text';

import { configs } from '../../../../constants/configs/configs';

export default function RenderConsumerSignUpNotEnabled({ currentYear }) {

    const { externalEndpoints } = configs;

    return (
        <Fragment>
            <GenericHeader
                id="welcome_spl"
                text="home.landingpage.welcome_header_spl"
                tag="h1"
                headerClassName={['mobile:grid-col-12 tablet:grid-col-fill']}
            />
            <GenericHeader
                id="alert_info"
                text="home.landingpage.information_spl"
                tag="h2"
                headerClassName={['mobile:grid-col-12 tablet:grid-col-fill']}
                textReplacements={{
                    currentYear
                }}
            />
            <div className="desktop:grid-col-12 tablet:grid-col-12 mobile-lg:grid-col-12 grid-col-12 informational__text" data-automation-id="informational-text">
                <Text
                    id="welcome_message"
                    text="home.landingpage.additional_info_spl"
                    display='block'
                />
                <span className="make-inline">
                    <strong>
                        <Text
                            id="welcome_message2"
                            class="highlight-text"
                            text="home.landingpage.additional_info_spl2"
                            display='block'
                        />
                    </strong>
                    <Text
                        id="welcome_message3"
                        text="home.landingpage.additional_info_spl3"
                        display='block'
                        linkText="home.landingpage.additional_info_link_spl3"
                        isReplacementALink={true}
                        path="https://pennie.com/coming-soon/"
                    />
                </span>
                <Text
                    id="welcome_message4"
                    text="home.landingpage.additional_info_spl4"
                    display='block'
                    linkText="home.landingpage.additional_info_link_spl4"
                    isReplacementALink={true}
                    path={externalEndpoints.GENERAL.HEALTH_CARE_GOV}
                />
            </div>
        </Fragment>
    );
}